import React, { useState } from "react";
import "./recuperar-senha.scss";
import { useHistory } from "react-router-dom";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  RequiredRule,
} from "devextreme-react/form";

import Button from "devextreme-react/button";

const RecoverPassword = () => {
  const [recoverPasswordForm] = useState({});
  const history = useHistory();

  const onRecoverPasswordClick = (e) => {
    e.preventDefault();
    alert(recoverPasswordForm.documento);
  };

  const buttonOptions = {
    text: "Enviar",
    type: "success",
    useSubmitBehavior: true,
  };

  return (
    <div className="recuperar-senha-main-div">
      <div className="recuperar-senha-card">
        <h2 style={{ marginTop: "-20px" }}>Recuperação senha</h2>
        <p>
          Por favor entre com seu CPF ou CNPJ que iremos mandar um email para
          recuperar sua senha!
        </p>
        <form onSubmit={onRecoverPasswordClick}>
          <Form
            id="form-cad"
            colCount={2}
            labelLocation={"top"}
            formData={recoverPasswordForm}
          >
            <GroupItem colCount={1} colSpan={2}>
              <SimpleItem dataField="documento" colSpan={2}>
                <RequiredRule message="Documento é obrigatório" />
                <Label text="CPF/CNPJ" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <br />
          <div className={"dx-field"}>
            <Button
              type={"default"}
              text={"Enviar"}
              useSubmitBehavior={true}
              width={"100%"}
            />
          </div>
        </form>
        <br />
        <p onClick={() => history.goBack()} className="link-go-back">
          Voltar para o login
        </p>
      </div>
    </div>
  );
};

export default RecoverPassword;
